import PropTypes from 'prop-types';
import Textarea from "components/form/Textarea/Textarea";
import { useState } from "react";
import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";
import Trans from "features/translation/components/Trans";
import Autocomplete from "components/form/Autocomplete/Autocomplete";
import UserDetail from "components/ui/UserDetail/UserDetail";
import CheckProfileVisible from "pages/Profile/CheckProfileVisible";
import HTMLContainer from "components/ui/HTML/HTMLContainer";
import ImageUpload from "components/form/ImageUpload/ImageUpload";

const MessageCreate = ({ receiver, replyToMessage, onCompleted }) => {
  const { hideDialog } = useDialog();
  const { postData } = useData();
  const [ saving, setSaving ] = useState(false);
  const [ sent, setSent ] = useState(false);
  const [ error, setError ] = useState();
  const [ selectedReceiver, setSelectedReceiver ] = useState(receiver?.uid);
  const [ message, setMessage ] = useState();
  const [ imageData, setImageData ] = useState();

  const onSave = async () => {
    if (!selectedReceiver) {
      setError('Er is nog geen ontvanger geselecteerd');
      return;
    }

    if (!message) {
      setError('Bericht is een verplicht veld');
      return;
    }

    setError();
    setSaving(true);

    const response = await postData('rest/message', {
      receiver: selectedReceiver,
      message: message,
      image: { target_id: imageData && imageData.fid[0].value },
    });

    let result;
    if (response?.status && response.status !== 500) {
      result = await response.json();
    }

    switch (response?.status) {
      case 200:
        setSent(true);
        if (onCompleted) {
          onCompleted(selectedReceiver, result);
        }
        break;

      case 400:
        setError(result.message);
        break;

      default:
        setError(`Het bericht kon niet worden verzonden (${ response?.status })`);
    }

    setSaving(false);
  };

  const selectAutocompleteResult = (result) => {
    setError();
    setSelectedReceiver(result?.uid);
  }

  const renderAutocompleteResult = (result) => {
    return <UserDetail username={ result.title }
                       image={ result.field_profile_photo }
                       subtext={ result.field_profile_city }/>;
  }

  let content;
  if (sent) {
    content = (
      <>
        <div>
          <Trans text={ 'Uw bericht is verzonden!' }/>
        </div>
        <div className="dialog__buttons dialog__buttons--end">
          <Button onClick={ () => hideDialog() } variant="secondary">Sluiten</Button>
        </div>
      </>
    )
  } else {
    content = (
      <>
        {
          !receiver?.id &&
          <div className={ `dialog__row` }>
            <h3>Selecteer een ontvanger</h3>
            <Autocomplete endpoint="rest/profile"
                          placeholder="Typ een deel van de naam om te zoeken..."
                          onRenderResult={ renderAutocompleteResult }
                          onSelect={ selectAutocompleteResult }/>
          </div>
        }
        {
          receiver && replyToMessage &&
            <div className={ `dialog__row` }>
              <h3>{ receiver.title.value } schreef:</h3>
              <HTMLContainer>
                { replyToMessage }
              </HTMLContainer>
            </div>
        }
        <div className={ `dialog__row` }>
          <h3>Uw bericht{ receiver && ` aan ${receiver.title.value}` } </h3>
          <Textarea onChange={ event => setMessage(event.target.value) } value={ message }/>
        </div>
        <div className={ `dialog__row` }>
          <ImageUpload title={ `Foto` }
                       subtitle={ `(niet verplicht)` }
                       type="at_message"
                       bundle="at_message"
                       field="image"
                       currentData={ imageData }
                       currentValue={ null }
                       onUploaded={ setImageData }/>
        </div>
        <div className="dialog__buttons dialog__buttons--end">
          <Button onClick={ onSave } variant="secondary">Versturen</Button>
        </div>
      </>
    );
  }

  return (
    <Dialog title={ replyToMessage ? 'Bericht beantwoorden' : 'Bericht sturen' }
            loading={ saving }
            errorMessage={ error }
            warnOnClose={ !sent }>
      <CheckProfileVisible>
        { content }
      </CheckProfileVisible>
    </Dialog>
  )
}

MessageCreate.propTypes = {
  receiver: PropTypes.object,
  replyToMessage: PropTypes.string,
  onCompleted: PropTypes.func,
}

export default MessageCreate;
